/**
 * The slot registrations of `web/documents` (1.I-3 deliverable 11): the Outline tab
 * (`rail.tabs.outline`) and the canon pill (`header.pills.canon`, deliverable 17).
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/documents']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { lazy } from 'react';

/**
 * Loaded on first use: the Outline reads the editor package, which this module's importers
 * (the slot collector, its specs) need not evaluate, and the rail shows it inside a `Suspense`.
 */
const OutlineTab = lazy(() =>
  import('./outline/outline-tab.js').then((module) => ({ default: module.OutlineTab })),
);

/** Lazy for the same reason: it reads the editor package (`useEditorHandle`). */
const CanonPill = lazy(() =>
  import('./canon/canon-pill.js').then((module) => ({ default: module.CanonPill })),
);

export const owner: WorkPackageId = '1.I-3';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 20, owner: '1.I-3', component: CanonPill },
  { slot: 'rail.tabs', order: 20, owner: '1.I-3', component: OutlineTab },
];
